import React from 'react';
import { Area, AreaChart, ResponsiveContainer, XAxis, YAxis, Tooltip } from 'recharts';
import { ThreatIncidents } from '../../services/analyticsService';

interface Props {
  data: ThreatIncidents;
}

const DEFAULT_MONTHLY_DATA = [
  { month: 'Apr', responseTime: 55 },
  { month: 'May', responseTime: 45 },
  { month: 'Jun', responseTime: 38 },
  { month: 'Jul', responseTime: 33 },
  { month: 'Aug', responseTime: 28 },
  { month: 'Sep', responseTime: 32 },
  { month: 'Oct', responseTime: 38 },
];

const ThreatIncidentsChart: React.FC<Props> = ({ data }) => {
  const chartData = data?.monthly_data?.length
    ? data.monthly_data.map((item) => ({
        month: item.month.substring(0, 3),
        responseTime: Math.round(item.average_response_time_minutes),
      }))
    : DEFAULT_MONTHLY_DATA;

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
      <h2 className="text-sm font-bold text-[#0c1e40]">Threat &amp; Incident Analytics</h2>
      <p className="text-xs text-gray-500 mt-1 mb-3">Average Response Time During Drills</p>
      <div className="h-36 w-full -ml-3">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={chartData} margin={{ top: 10, right: 10, left: -15, bottom: 0 }}>
            <defs>
              <linearGradient id="areaGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.4} />
                <stop offset="95%" stopColor="#3b82f6" stopOpacity={0.05} />
              </linearGradient>
            </defs>
            <XAxis
              dataKey="month"
              tickLine={false}
              axisLine={false}
              tick={{ fontSize: 10, fill: '#64748b' }}
            />
            <YAxis
              domain={[0, 60]}
              ticks={[0, 20, 40, 60]}
              tickLine={false}
              axisLine={false}
              tick={{ fontSize: 10, fill: '#64748b' }}
            />
            <Tooltip
              content={({ active, payload }) => {
                if (active && payload && payload.length) {
                  return (
                    <div className="p-2 bg-white border border-gray-200 rounded-lg shadow-md text-xs">
                      <p className="font-bold text-[#0c1e40]">{payload[0].payload.month}</p>
                      <p className="text-blue-600 font-semibold">{payload[0].value} mins</p>
                    </div>
                  );
                }
                return null;
              }}
            />
            <Area
              type="monotone"
              dataKey="responseTime"
              stroke="#3b82f6"
              strokeWidth={2}
              fill="url(#areaGradient)"
              dot={{ r: 3.5, fill: '#3b82f6', stroke: '#ffffff', strokeWidth: 1.5 }}
              activeDot={{ r: 5 }}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ThreatIncidentsChart;
